<script lang="ts">
    import {formatPrice} from "../utils/currency";
    import {BCCurrenciesRates, BCSiteCurrency, platform, priceWidth} from "../store/store";
    import {containerWidth} from "../utils/containerWidth";
    import type {Currency} from "@fast-simon/types";
    import {currentCurrencyRate} from "../utils/getBCCurrentCurrency";
    import {convertPrice} from "../utils/currencyConverter";
    import {tick} from "svelte";
    import useCurrencyConverter from "../hooks/useCurrencyConverter";



    /* Props */
    export let currency: string;
    export let price: number;
    export let previousPrice: string;
    export let minPrice: string;
    export let imgSize: string

    /* State */
    let smallContainer: boolean = false
    let exchangeRate: number = 1
    let displayCurrency: Currency | undefined = undefined;
    let displayPrice: number
    let displayPreviousPrice: string | undefined

    $: if ($priceWidth > Number(imgSize)) {
        smallContainer = true
    }
    const refreshCurrencies = () => {
         const {price: sitePrice, currency: siteCurrency} = convertPrice($platform, Number(price), currency);
         const {price: siteComparePrice, currency: siteCompareCurrency} = convertPrice($platform, Number(previousPrice), currency);
         displayPrice = sitePrice;
         displayCurrency = siteCurrency;
         displayPreviousPrice = String(siteComparePrice);
    }

    $: if($platform && price && currency) {
        refreshCurrencies();
    }


     /* BigCommerce price and currency */
    $: exchangeRate = $platform === "BigCommerce" && $BCSiteCurrency ? currentCurrencyRate(currency, $BCSiteCurrency, $BCCurrenciesRates) : 1

    /* listen to Shopify currency converter changes and apply logic to products state */
    useCurrencyConverter(refreshCurrencies);

    /* listen to BigCommerce currency changes and apply logic to products state */
    $: if($BCSiteCurrency) {
        tick().then(() => {
            refreshCurrencies();
        })
    }
</script>
<div style={`min-width: ${imgSize}px`} class="fs-recommendation-price-container">
    {#if minPrice > 0}
        <span class:price-container={smallContainer} class="fs-recommendation-product-price">From&nbsp;{formatPrice(displayPrice, displayCurrency)}</span>
    {:else if previousPrice > 0}
    <span class:price-container={smallContainer} use:containerWidth="{priceWidth}" class="fs-recommendation-product-price">
        {formatPrice(displayPrice, displayCurrency)}&nbsp;<span class="previous-price fs-recommendation-product-previous-price">{formatPrice(displayPreviousPrice, displayCurrency)}</span>
    </span>
    {:else}
        <span class:price-container={smallContainer} class="fs-recommendation-product-price">{formatPrice(displayPrice, displayCurrency)}</span>
    {/if}
</div>
<style>

    .fs-recommendation-price-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column-reverse;
        white-space: nowrap;
        height: 2rem;
    }

    .price-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 5px 0;
        white-space: nowrap;
    }


    .previous-price {
        text-decoration: line-through;
        color: #939597;
    }

</style>